import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./restable.css";
import Tooltip from "@material-ui/core/Tooltip";
import { Icon } from "semantic-ui-react";
import moment from 'moment';
import Xml_Editor from "../XmlEditor/XmlEditor";

const ResponseRecorsCountryMap = {
  GB: "ediTxnResponse",
  US: "ediTxnResponse",
  CA: "cbsaTxnResponse",
  CA_CARM: "carmTransactionResponses"
};
function ResponseRecords(props) {
  //debugger;
  const country = useSelector((state) => props.isXMLEnabled ? "CA_CARM" : window.shipmentCountry || state.isf?.currentJobData.shipment.countryOfBusiness || props.countryOfBusiness);
  const RecordsData = useSelector((state) => state?.ediResp?.ediRespRecords);
  const Records = RecordsData.eventMessage ? RecordsData.eventMessage?.[ResponseRecorsCountryMap[country]] : [];
  const loader = useSelector((state) => state?.ediResp?.loading);
  const shipmentID = useSelector((state) => window.shipmentId || state.isf?.shipmentID || props.shipmentId);
  const [recordsHeader, setrecordsHeader] = useState();
  const [textCopied, setTextCopied] = useState({});
  const selectedRow = useSelector((state) => state.rowSelected?.selectedRow);
  useEffect(() => {
    findingMaxvalueofRecord();
  }, [shipmentID]);
  const findingMaxvalueofRecord = () => {
    let recordsSize = [];

    Records &&
      Records.map((recRow, i) => {
        recordsSize.push(recRow.maxLength+1);
      });
    setrecordsHeader(recordsSize);
  };
  const getTableData = (index, reqrecords) => {
    if (reqrecords.record) {
      return reqrecords.record.split("")[index] ? reqrecords.record.split("")[index] : "";
    }
  };

  
  const copytoclipboard = (response,responseid) => {
    
    if(response){

      let emptyArr = [];
      let finalArray = "";
      for (let i = 0; i < response.recordResponse.length; i++) {
        {
          country === "US" ? emptyArr.push(response.recordResponse[i] && "[" + response.recordResponse[i].record + "]") :
           emptyArr.push(response.recordResponse[i] && response.recordResponse[i].record);
        }
      }
      finalArray = emptyArr.join("\n");
      navigator.clipboard.writeText(finalArray);
      textCopied[responseid]=true;
      setTextCopied({...textCopied});
      hidecopiedtextalert(responseid);
      
    }

  };

  const hidecopiedtextalert = (responseid) => {
    setTimeout(() => {
      textCopied[responseid]=false;
      setTextCopied({...textCopied});
    }, 2000);
  };

  const createDyanamicArray = (len) => {
    let arr = [];
    for(var i=0; i<=len; i++) {
      arr.push(i.toString());
    }
    return arr;
  }

  let j, color = "#267675";
  
  return (
    <div>
      {Records && loader == false ? (
        <div>
          {country === "CA_CARM" ? 
          <div> 
            <Xml_Editor shipmentId={shipmentID} records={Records} />
          </div> :
          <div>
          <h1>Response Records</h1>
          <div>
          { 
            selectedRow.requestTime && 
              <span>
              <strong>Response Filed On: </strong>
              {
                `${moment(new Date(selectedRow.requestTime)).format("MM-DD-YY hh:mm:ss")} ${selectedRow.response || ""}`
              }
              </span>
          }
          </div>
          
          {Records.map((records, i) => {
            let maxLengthArray = createDyanamicArray(records.maxLength+1);
            let recordHeaderArray = [];
            if(recordsHeader && recordsHeader[i]){
              recordHeaderArray = createDyanamicArray(recordsHeader[i]);
            }
            return (
            <div key={i}>
               <Tooltip placement="top" arrow title="Copy To Clipboard" aria-label="Copy To Clipboard">
            <Icon name="file alternate outline" disabled={textCopied[records.responseid] ? true : false} onClick={(e)=>copytoclipboard(records,records.responseid)}
             style={{ fontSize: "18px", cursor: "pointer" }} />
          </Tooltip>
          {textCopied[records.responseid] && <span id="copied-text-span">copied successfully !</span>}

              <h3>Response ID : {records.responseid}</h3>
              {records.responsetime && <React.Fragment><b>
                [UTC: {moment(new Date(records.responsetime)).tz("UTC").format('ddd, MMM DD YYYY, HH:mm zz')}]
                [EST: {moment(new Date(records.responsetime)).tz('America/New_York').format('ddd, MMM DD YYYY, HH:mm zz')}]
              </b><br/></React.Fragment>}
              
              <div className="res-table-wrap">
                <table className="res-table">
                  <thead>
                    <tr>{
                    recordsHeader && 
                    recordHeaderArray.map((e, i) => {
                      color = "#267675";
                      if(i%10 == 0){
                        j = i; 
                        color = "#60afad"
                      } 
                      return (
                      <th style={{"backgroundColor": color}} key={i}>{!i ? "" : (j && i>j)?(i-j): i}</th>
                    )
                    })}
                    </tr>
                  </thead>
                  <tbody>
                    {console.log("records.recordResponse ===== ", records.recordResponse)}
                    {records.recordResponse
                      ? records.recordResponse.map((recordResponses, i) =>
                          recordResponses.record && recordResponses.record.length > 0 ? (
                            <tr key={i}>
                              {maxLengthArray.map((e, j) => (
                                <td key={j}  className={j===0?"rowcounter":""}>{j===0 ? <span>{i+1}</span> : getTableData(j-1, recordResponses)}</td>
                              ))}
                            </tr>
                          ) : null
                        )
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })}</div>}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default React.memo(ResponseRecords);
